import request from '@/shared/api/request';

export const disableDatabaseBackups = (uuid: string): Promise<void> =>
  request({
    url: `/databases/${uuid}/`,
    method: 'POST',
    data: { action: 'disable_backups' },
  });
